import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router';
import { IsLoggedIn } from '../utility/features/helpers/authHelper';

const PrivateRoute = ({ children }) => {
  
  const isLoggedIn = IsLoggedIn();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if(!isLoggedIn) {
      navigate("/login", { replace: true, state: { from: `${location.pathname}${location.search}` } });
    }
  }, []);
  
  return isLoggedIn ? (
    <>{children}</>
  ) : <></>
}

export default PrivateRoute;